<script>
  import StartTrendingHeader from '@app-components/post-onboarding/StartTrendingHeader.svelte';
  export let mobile = false;
</script>

<style lang="scss">
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    &.desktop {
      width: 437px;
    }
    &.mobile {
      width: 100%;
      .image-container {
        margin-bottom: -40px;
        margin-top: -30px;
      }
    }
  }
  .centre-image {
    width: 100%;
  }
  .image-container {
    margin-bottom: 60px;
  }
</style>

<div class="content-container start-trending-step-fourth {mobile ? 'mobile' : 'desktop'}" style="display: none;">
  <StartTrendingHeader mobile={mobile} currentStep={'fourth'} />
  <div class="image-container">
    <img class="centre-image" src="/images/list-optimizations/step-four{mobile ? '-mobile' : ''}.png" />
  </div>
</div>
